export const loginTargetMap = {
    physio: '/all_patients',
    fitness: '/fitness_assessment',
    schedule_results: '/schedule_results',
    roadmap: '/roadmap',
    patient: '/patient_overview',
};